import {
  AlertDialog,
  LocalizedString,
  unsafeLocalizedString,
  WarningIcon,
} from "@dbn/omnichannel-design-system-g4p";

type Props = {
  onCancel: () => unknown;
  onDismiss: () => unknown;
  ariaLabel?: LocalizedString;
};

export function NewVersionAlert(props: Props) {
  return (
    <AlertDialog
      ariaLabelMessageForCloseIcon={props.ariaLabel}
      title={unsafeLocalizedString("New Version Available")}
      message={unsafeLocalizedString(
        "You are not running the latest version of the application, please reload the tab(CTRL+R) " +
          "when possible or press RELOAD NOW(these actions will restart the flow). This warning is shown only in SIT/UAT/HF."
      )}
      confirmLabel={unsafeLocalizedString("RELOAD NOW")}
      cancelLabel={unsafeLocalizedString("OK")}
      onDismiss={props.onDismiss}
      type={"confirmation"}
      onConfirm={() => window.location.reload()}
      onCancel={props.onCancel}
      icon={WarningIcon}
    />
  );
}
